import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Checkbox } from '@thd-olt-component-react/checkbox';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/heading';
import PriceMessage from '../Partials/PriceMessage.component';
import * as analytics from '../../analytics/frequentlyboughttogether-analytics';
import './Legacy.style.scss';
// eslint-disable-next-line import/no-cycle
import FrequentlyBoughtTogether from '../../FrequentlyBoughtTogether.component';

class LegacyFBT extends Component {

  // eslint-disable-next-line react/static-property-placement
  static contextType = ExperienceContext;

  onChangeCheckbox = (id) => {
    const { onChangeCheckbox } = this.props;
    onChangeCheckbox(id);
  };

  onAddToCartClick = () => {
    const { products = [], itemId } = this.props;
    let analyticsItems = [];
    products.forEach((product) => {
      if (product.checked) {
        if (product.itemId !== itemId) {
          analyticsItems.push(product);
        }
        this.onChangeCheckbox(product.itemId);
      }
    });
    analytics.fbtAddToCartAnalytics({ analyticsItems });
  };

  getCart(items) {
    const isMajorAppliance = items.every((item) => item.product?.identifiers?.productType === 'MAJOR_APPLIANCE');
    const { channel } = this.context;
    const options = {
      host: typeof window !== 'undefined'
        ? window.location.origin
        : null,
      channel,
      paypal: false,
      misship: false,
      directCheckout: !isMajorAppliance,
      alterBrowserHistory: isMajorAppliance ? null : true
    };
    const zipCode = typeof window !== 'undefined' ? window.cookieUtils?.readBrowserCookie?.('THD_AOL') : '';
    const itemDetails = items.filter((item) => item.checked)
      .map((item) => {
        const isMajorApplianceItem = item.product?.identifiers?.productType === 'MAJOR_APPLIANCE';
        if (isMajorApplianceItem) {
          return {
            itemId: String(item.itemId),
            quantity: 1,
            fulfillmentMethod: 'DirectDelivery',
            fulfillmentLocation: zipCode || '',
          };
        }
        return {
          itemId: String(item.itemId),
          quantity: 1
        };
      });

    return {
      itemDetails,
      options
    };
  }

  getPricingDetails = (item) => {
    const {
      mapAboveOriginalPrice, promotion, message,
    } = item.pricing;
    const dollarOff = promotion?.dollarOff || 0;
    return (
      <>
        {mapAboveOriginalPrice
          && (
            <div className="fbtProductLine__priceContainer">
              <span>
                {dollarOff > 0
                && (
                  <span
                    className="fbtStrikethroughPrice"
                  >{this.formatCurrency(item.pricing.value + dollarOff)}
                  </span>
                )}
                <span className="fbtProductLine__price"> See Low Price in Cart</span>
              </span>
            </div>
          )}
        {!mapAboveOriginalPrice
        && (
          <div className="fbtProductLine__priceContainer">
            {dollarOff > 0
              ? (
                <span>
                  <span
                    className="fbtStrikethroughPrice"
                  >{this.formatCurrency(item.pricing.value + dollarOff)}
                  </span>
                  <span
                    className="fbtProductLine__price"
                  > {this.formatCurrency(item.pricing.value)}
                  </span>
                </span>
              )
              : (
                <span
                  className="fbtProductLine__price"
                >{this.formatCurrency(item.pricing.value + dollarOff)}
                </span>
              )}
          </div>
        )}
      </>
    );
  };

  getPrimaryLabel = (item) => {
    const { productName } = item;
    const productDescriptionClasses = classNames(
      'fbt__productdesc',
      'fbt__productdesc--truncate', {
        fbt__productdesc__opacity: !item.checked
      });
    return (
      <>
        <div className={productDescriptionClasses}>
          <b>This item: </b>{item && productName} {' '}
        </div>
        {this.getPricingDetails(item)}
      </>
    );
  };

  getLink = (item = {}) => {
    const { products } = this.props;
    const anchor = products[0].itemId;
    const displayPosition = products.findIndex((i) => i.itemId === item.itemId);
    const {
      brand, canonicalURL, productName
    } = item;
    const productDescriptionClasses = classNames(
      'fbt__productdesc',
      'fbt__productdesc--truncate', {
        fbt__productdesc__opacity: !item.checked
      });
    return (
      <>
        <div className={productDescriptionClasses}>
          <a
            href={canonicalURL}
            onClick={() => analytics.track({
              itemId: anchor,
              displayPosition
            })}
          >
            {brand} {' '}
            {productName} {' '}
          </a>
        </div>
        {this.getPricingDetails(item)}
      </>
    );
  };

  getAddToCartMessage = (selectedItemsCount, priceMsgCount) => {
    const message = {
      isDisable: false,
      atcMessage: 'Add to cart'
    };
    if (selectedItemsCount === 1) {
      message.priceMessage = 'Price:';
    } else if (selectedItemsCount === 2) {
      message.priceMessage = 'Price for both:';
      message.atcMessage = 'Add both to cart';
    } else if (selectedItemsCount === 3) {
      message.priceMessage = 'Price for all three:';
      message.atcMessage = 'Add all three to cart';
    } else if (selectedItemsCount === 4) {
      message.priceMessage = 'Price for all four:';
      message.atcMessage = 'Add all four to cart';
    } else if (selectedItemsCount === 5) {
      message.priceMessage = 'Price for all five:';
      message.atcMessage = 'Add all five to cart';
    } else if (selectedItemsCount === 0) {
      message.priceMessage = '';
      message.isDisable = true;
    }
    if (priceMsgCount > 0) message.priceMessage = '';
    return message;
  };

  getItemImage = (item) => {
    const { products } = this.props;
    const anchor = products[0].itemId;
    const displayPosition = products.findIndex((i) => i.itemId === item.itemId);
    const imageUrl = item.imageURL.replace('<SIZE>', 145);
    const imageClasses = classNames('fbtProductImage', {
      fbtProductImage__opacity: !item.checked
    });

    return item.type === 'primary'
      ? (
        <img
          className={imageClasses}
          src={imageUrl}
          alt={item.productLabel}
          loading="lazy"
        />
      )
      : (
        <a
          href={item.canonicalURL}
          onClick={() => analytics.track({
            itemId: anchor,
            displayPosition
          })}
        >
          <img
            className={imageClasses}
            src={imageUrl}
            alt={item.productLabel}
            loading="lazy"
          />
        </a>
      );
  };

  formatCurrency = (price) => {
    const value = parseFloat(price);
    let priceFormat;
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(Number(value)) || value === 0) return '';
    if (value < 1) {
      priceFormat = `${(Number(value) * 100).toFixed(0)}¢`;
    } else {
      priceFormat = `$${Number(value).toFixed(2)}`;
    }
    return priceFormat;
  };

  render() {
    const { itemId, products, storeId } = this.props;
    const checked = products.filter((item) => item.checked).map((item) => item.itemId);
    const cart = this.getCart(products);
    const priceMsgCount = FrequentlyBoughtTogether.getFinalPriceCount(products);
    const message = this.getAddToCartMessage(checked.length, priceMsgCount);
    let totalPrice = {};
    if (checked.length) {
      totalPrice = FrequentlyBoughtTogether.getTotalPrice(products);
    }
    const count = products.reduce((n, item) => (item.type !== 'primary' ? n + 1 : n), 0);
    const fbtPlusIcon = classNames(
      'u__bold',
      'fbtPlus', {
        'fbtPlus--mobile':
          cart.options.channel === 'mobile'
      }
    );

    const fbtProductLine__item = classNames({ // eslint-disable-line
      fbtProductLine__item:
        cart.options.channel === 'mobile'
    });

    if (count > 0) {
      return (
        <div className="frequently-bought-together" data-type="container">
          <meta data-prop="name" content="pip_fbt" />
          <Heading title="Frequently Bought Together" underline />
          <div className="fbt_label">
            <div className="fbt_price fbt_container">
              {products.length > 1 && products.map((item, index) => {
                return (
                  <Fragment key={`fbt-product-image-${item.itemId}-${index}`}>
                    {item.type === 'primary' ? '' : <span className={fbtPlusIcon}>+</span>}
                    <div
                      className="fbtProductImageCont"
                      key={`fbt-Product-Image ${item.itemId}`}
                      data-itemid={item.itemId}
                      data-type="product"
                    >
                      <meta data-prop="productID" content={item.itemId} />
                      {this.getItemImage(item)}
                    </div>
                  </Fragment>
                );
              })}
              {cart.options.channel !== 'mobile'
              && (
                <PriceMessage
                  cartOptions={cart.options}
                  cartReqParams={cart.itemDetails}
                  channel={cart.options.channel}
                  itemId={itemId}
                  storeId={storeId}
                  message={message}
                  onAddToCartClick={this.onAddToCartClick}
                  pricing={totalPrice}
                  hideBadge
                />
              )}
            </div>
          </div>
          <div className="fbt__prodcontainer u__clearfix">
            {products.length > 1 && products.map((item, index) => {
              return (
                <div
                  key={`fbt-product-line-${item.itemId}-${index}`}
                  className={classNames('fbtProductLine', { fbtOpacitizer: !item.checked })}
                >
                  <Checkbox.Group>
                    <Checkbox
                      className={fbtProductLine__item} // eslint-disable-line
                      key={`fbt-product-line-${item.itemId}-${index}`}
                      id={item.itemId}
                      onChange={() => this.onChangeCheckbox(item.itemId)}
                      checked={item.checked}
                      value={`${item.itemId}`}
                    >{
                        item.type === 'primary'
                          ? this.getPrimaryLabel(item)
                          : this.getLink(item)
                      }
                    </Checkbox>
                  </Checkbox.Group>
                </div>
              );
            })}
          </div>
          {cart.options.channel === 'mobile'
          && (
            <PriceMessage
              cartOptions={cart.options}
              cartReqParams={cart.itemDetails}
              channel={cart.options.channel}
              itemId={itemId}
              storeId={storeId}
              message={message}
              onAddToCartClick={this.onAddToCartClick}
              pricing={totalPrice}
              hideBadge
            />
          )}
        </div>
      );
    }
    return null;
  }
}

LegacyFBT.propTypes = {
  itemId: PropTypes.string.isRequired,
  onChangeCheckbox: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string
  })),
  product: PropTypes.shape({}).isRequired,
  storeId: PropTypes.string
};

LegacyFBT.defaultProps = {
  products: [],
  storeId: null
};

LegacyFBT.displayName = 'LegacyFBT';
export default LegacyFBT;
